<template>
  <a-layout-sider
    :width="settings.leftMenuWidth"
    :collapsible="settings.isMobileView ? false : true"
    :collapsed="settings.isMenuCollapsed && !settings.isMobileView"
    :class="{
      [$style.menu]: true,
      // [$style.dark]: settings.menuColor === 'dark',
      // [$style.unfixed]: settings.isMenuUnfixed,
      // [$style.shadow]: settings.isMenuShadow,
    }"
    @collapse="onCollapse"
  >
    <div
      :class="$style.menuOuter"
      :style="{
        width:
          settings.isMenuCollapsed && !settings.isMobileView
            ? '80px'
            : settings.leftMenuWidth + 'px',
        height:
          settings.isMobileView || settings.isMenuUnfixed
            ? 'calc(100% - 64px)'
            : 'calc(100% - 110px)',
      }"
    >
      <div :class="$style.logoContainer">
        <div :class="$style.logo">
          <router-link :to="logoLinkTo">
            <img
              v-if="!settings.isMenuCollapsed"
              width="220"
              :src="logoSrc"
            />
            <img v-else width="45" src="../../../assets/img/logo-perki.svg" />
          </router-link>
        </div>
      </div>
      <perfect-scrollbar :style="{ height: 'calc(100% - 110px)', overflow: 'auto' }">
        <a-menu
          v-model:open-keys="openKeys"
          :inline-collapsed="settings.isMobileView ? false : settings.isMenuCollapsed"
          :mode="'inline'"
          :selected-keys="selectedKeys"
          :inline-indent="15"
          :class="$style.navigation"
          @click="handleClick"
          @openChange="handleOpenChange"
        >
          <template v-for="(item, index) in filteredMenu" :key="item.key || index">
            <a-menu-item-group v-if="item.category">
              <template #title>
                <span style="color: #c34f6b">{{ item.title }}</span>
              </template>
            </a-menu-item-group>
            <item v-if="!item.children && !item.category" :menu-info="item" :styles="$style" />
            <sub-menu v-if="item.children" :menu-info="item" :styles="$style" />
          </template>
        </a-menu>
      </perfect-scrollbar>
    </div>
  </a-layout-sider>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import find from 'lodash/find'
import { getMenuDashboard } from '@/services/menu/dashboard'
import SubMenu from './partials/submenu'
import Item from './partials/item'

export default {
  name: 'MenuLeft',
  components: { SubMenu, Item },
  setup() {
    const store = useStore()
    const route = useRoute()
    let menuData = computed(() => getMenuDashboard)
    let filteredMenu = ref([])
    let selectedKeys = ref([])
    let openKeys = ref([])
    let settings = computed(() => store.getters.settings)
    let isMenuCollapsed = computed(() => store.getters.settings.isMenuCollapsed)
    let user = computed(() => store.getters['user/user'])
    let pathname = computed(() => route.name)
    let logoLinkTo = computed(() => (route.path.startsWith('/mobile-cms') ? '/mobile-cms/member-application/dashboard' : '/'))
    let logoSrc = computed(() => {
      if (route.path.startsWith('/mobile-cms') || route.meta.isMobileCms) {
        return require('@/assets/img/PERKI MOBILE.svg')
      }
      return require('@/assets/img/PERKI E-OFFICE.svg')
    })

    const onCollapse = (collapsed, type) => {
      const value = !settings.value.isMenuCollapsed
      store.commit('CHANGE_SETTING', { setting: 'isMenuCollapsed', value })
    }

    const handleClick = (e) => {
      if (e.key === 'settings') {
        store.commit('CHANGE_SETTING', {
          setting: 'isSettingsOpen',
          value: true,
        })
        return
      }
      selectedKeys.value = [e.key]
    }

    const handleOpenChange = (openKeys) => {
      openKeys.value = openKeys
    }

    const setSelectedKeys = () => {
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item)
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key))
          }
          return flattenedItems
        }, [])
      const selectedItem = find(
        flattenItems(filteredMenu.value.filter((e) => !e.category).concat(), 'children'),
        ['url', route.path],
      )
      console.log('Selected item found:', selectedItem, 'Current path:', route.path)
      selectedKeys.value = selectedItem ? [selectedItem.key] : []
    }

    const buildFilteredMenu = () => {
      const isCmsMode = route.meta.isMobileCms === true

      if (isCmsMode) {
        // CMS mode: filter by actual mobile_cms_role (super_admin → mobile_cms_super_admin, admin → mobile_cms_admin)
        const cmsRole = localStorage.getItem('mobile_cms_role') || ''
        const virtualRole = 'mobile_cms_' + cmsRole
        filteredMenu.value = menuData.value.filter((item) => {
          if (!item.roles) return false
          return item.roles.includes(virtualRole)
        })
        return
      }

      const storedUserData = localStorage.getItem('perki_user')
      const storedGroupCategory = localStorage.getItem('perki_group_category')

      if (!storedUserData) {
        filteredMenu.value = []
        return
      }

      const userData = JSON.parse(storedUserData)
      const userRole = userData.role || ''

      if (storedGroupCategory === 'Cabang') {
        filteredMenu.value = menuData.value.filter((item) => {
          if (!item.roles) return true
          return (
            item.roles.includes(userRole) &&
            item.roles.includes('cabang') &&
            !item.roles.includes('mobile_cms_admin') &&
            !item.roles.includes('mobile_cms_super_admin')
          )
        })
      } else {
        filteredMenu.value = menuData.value.filter((item) => {
          if (!item.roles) return true
          return (
            item.roles.includes(userRole) &&
            !item.roles.includes('mobile_cms_admin') &&
            !item.roles.includes('mobile_cms_super_admin')
          )
        })
      }
    }

    onMounted(() => {
      buildFilteredMenu()
      setSelectedKeys()
    })

    watch(route, () => {
      buildFilteredMenu()
      setSelectedKeys()
    })
    watch(isMenuCollapsed, () => (openKeys.value = []))

    return {
      menuData,
      selectedKeys,
      openKeys,
      settings,
      user,
      onCollapse,
      handleClick,
      handleOpenChange,
      filteredMenu,
      logoLinkTo,
      logoSrc,
    }
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';

:deep(.ant-menu-inline .ant-menu-item) {
  border-radius: 100px !important;
  margin: 4px 8px !important;
  overflow: hidden;
}

:deep(.ant-menu-item-selected) {
  background-color: #e10f28 !important;
  border-radius: 100px !important;

  .ant-menu-title-content {
    color: white !important;
  }

  i {
    color: white !important;
  }
}

:deep(.ant-menu-item-selected::after) {
  display: none !important;
}
</style>
